import { useWebsite } from "../../../shared/hooks/useWebsite";
import { useEffect, useRef } from "react";
import axios, { CancelTokenSource } from "axios";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { websiteBuilderExitEditor, websiteBuilderLoadEditor } from "redux/actions/websiteBuilder/editor/websiteBuilderEditor";
import { TWebsiteBuilderEditorLoadingStatus } from "redux/reducers/websiteBuilder/websiteBuilderEditor";
import { IWebsiteBuilderWebsite } from "redux/reducers/models/websiteBuilder";
import { useTranslation } from "react-i18next";
import { isWholeNumber } from "helpers/Helpers";

interface IUseLoadWebsiteBuilderEditorArgs {
  pastWebsiteVersionIdParam: string;
}

interface IUseLoadWebsiteBuilderEditor {
  website: IWebsiteBuilderWebsite;
  editorLoadingStatus: TWebsiteBuilderEditorLoadingStatus;
}

export function useLoadWebsiteBuilderEditor(args: IUseLoadWebsiteBuilderEditorArgs): IUseLoadWebsiteBuilderEditor {
  const dispatch = useAppDispatch();

  const { t } = useTranslation();
  
  const { website, websiteLoadingStatus } = useWebsite({ websiteMustExist: true });
  
  const { editorLoadingStatus } = useAppSelector(store => store.websiteBuilderStore.editor);

  const exitCancelSource = useRef<CancelTokenSource>(axios.CancelToken.source());

  useEffect(() => {
    return () => {
      exitCancelSource.current.cancel();
      dispatch(websiteBuilderExitEditor());
    };
  }, []);

  useEffect(() => {
    if (
      website?.id != null &&
      website?.current_version_id != null &&
      websiteLoadingStatus === "succeeded" &&
      editorLoadingStatus === "standby"
    ) {
      const pastWebsiteVersionId = isWholeNumber(args.pastWebsiteVersionIdParam) ? Number(args.pastWebsiteVersionIdParam) : null;
      const viewingPastVersion = pastWebsiteVersionId != null;
      const websiteVersionId = viewingPastVersion ? pastWebsiteVersionId : website.current_version_id;

      void dispatch(websiteBuilderLoadEditor(
        website.id,
        websiteVersionId,
        viewingPastVersion,
        exitCancelSource.current.token,
        t,
      ));
    }
  }, [
    website?.id,
    website?.current_version_id,
    websiteLoadingStatus,
    editorLoadingStatus,
    args.pastWebsiteVersionIdParam,
  ]);

  return {
    website,
    editorLoadingStatus,
  };
}